import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PipeSpecificationCodes } from 'src/app/Modules/settings/models/idms/pipe-specification.model';

@Component({
    selector: 'app-add-pipe-spec',
    templateUrl: './add-pipe-spec.component.html',
    styleUrls: ['./add-pipe-spec.component.scss'],
})
export class AddPipeSpecComponent implements OnInit {
    @Input() mode: string;
    @Input() pipeSpec: PipeSpecificationCodes;
    @Input() tittle: string;

    addPipeSpecForm: UntypedFormGroup;
    stateOptions: any = [
        { label: 'mm', value: 0 },
        { label: 'in', value: 1 },
    ];
    constructor(
        private ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder
    ) {}

    ngOnInit(): void {
        this.createFormControls();
    }

    //creating form control
    createFormControls() {
        this.addPipeSpecForm = this.formBuilder.group({
            name: [this.pipeSpec?.name, [Validators.required]],
            discription: [this.pipeSpec?.description],
            pipeSizeType: [0, [Validators.required]],
        });
    }

    addButtonClick() {
        this.ngbActiveModal.close(this.addPipeSpecForm.value);
        //write logic for adding pipespec
    }

    closeClick() {
        this.ngbActiveModal.close(false);
    }

    // async onChange(event) {
    //     if (event.value == 0) {
    //     } else {
    //     }
    // }
}
